import httpClient from "../../../client/httpClient";
import { fetchCountries } from "../locations/locationApi";
import { fetchShippingFees } from "../shippingFees/shippingFeesApi";
import { mergeOrderWithSnapshot } from "../orders/ordersService";

export const fetchPayouts = async ({ filters }) => {
    try {
        const params = {};
        if (filters.sellerId !== null && filters.sellerId !== undefined) {
            params.sellerId = filters.sellerId;
        }
        if (filters.status !== null && filters.status !== undefined) {
            params.status = filters.status;
        }
        const res = await httpClient.get("/v1/api/payouts", { params });

        const shippingFees = await fetchShippingFees(["01", "02"]);
        const countries = await fetchCountries();

        const payouts = res.data.map((payout) => ({
            ...payout,
            orders: mergeOrderWithSnapshot(payout.orders, countries, shippingFees)
        }));

        return {
            content: payouts,
            pageNo: 1,
            pageSize: 100,
            totalPages: 1,
            totalElements: payouts.length,
            last: true
        };
    } catch (error) {
        console.log("Error fetching payouts", error);
        throw error;
    }
};

export const requestPayout = async ({ orderIds, totalAmount, sellerId }) => {
    try {
        const res = await httpClient.post("/v1/api/payouts", {
            orderIds,
            totalAmount,
            sellerId
        });
        return res.data;
    } catch (error) {
        console.log("Error requesting payout", error);
        throw error;
    }
};

export const updatePayout = async (id, payload) => {
    try {
        const { note, receipts } = payload;
        const formData = new FormData();
        receipts.forEach((file) => {
            formData.append("receipts", file.source);
        });

        const res = await httpClient.patch(`/v1/api/payouts/${id}?note=${note}`, formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
        return res.data;
    } catch (error) {
        console.log("Error updating payout", error);
        throw error;
    }
};
